declare global {
	interface Window {
		dataLayer: unknown[]
		google_tag_manager: unknown
	}
}

const gtmDebug = false

window.dataLayer = window.dataLayer ?? []

export const dataLayerPush = (props: Record<string, unknown>) => {
	if (gtmDebug) {
		console.log('GTM DEBUG: Push into dataLayer:', props)
		return
	}

	window.dataLayer.push(props)
}
